module.exports = __webpack_public_path__ + "img/6.7adaa872.jpg";